import './search.less'

import ArticleLink, {ArticleType} from '../partials/features/articlelink'
import {Image, Input, m} from '@codeurs/front'
import {PagedLoader, pagedFilters} from 'views/loader/pagedloader'
import Publication, {
	PublicationType
} from '../partials/features/publicationlink'

import Button from 'views/layout/button'
import Container from 'views/layout/container'
import Layout from 'views/layout'
import Link from 'views/layout/link'
import searchImage from 'assets/icons/searchiconbig.svg'
import {t} from 'store'

type SearchResultType =
	| {channel: 'article'} & ArticleType
	| {channel: 'publication'} & PublicationType

export default class Search extends Layout {
	state = pagedFilters(({single}) => ({
		query: single('query')
	}))
	view() {
		return m('.search', [m(Container, [this.viewTop(), this.viewResults()])])
	}

	static viewCmsLink(attrs) {
		return null
	}

	viewTop() {
		return m('.search-top', [
			m('input.search-top-input', {
				type: 'text',
				name: 'search',
				value: this.state.query.valueOf(),
				placeholder: t('search.term'),
				onchange: e => {
					this.state.query.add(e.target.value)
				}
			}),
			m(Link,
				{
					onclick: this.viewResults(),
					className: 'search-top-link'
				},
				m(Image, {
					class: 'search-top-image',
					src: searchImage,
					alt: 'Search Image'
				})
			)
		])
	}

	viewResults() {
		if (
			!this.state.query.size ||
			this.state.query.valueOf().toString().length < 3
		)
			return m('.search-loader', this.viewInfo(0, true))

		return m('.search-loader',
			m(PagedLoader,
				{
					url: '/api/search',
					filters: this.state
				},
				({data, total}) => {
					return [
						this.viewInfo(total, false),
						data.map((searchResult: SearchResultType, i) => {
							switch (searchResult.channel) {
								case 'article':
									const {key, ...articleResult} = searchResult
									return m('.searchcontainer', [
										m(ArticleLink, {
											mod: 'search',
											...articleResult,
											tags: this.findArticleTags(searchResult)
										}),
										i != data.length - 1 && m('.search-line')
									])
								case 'publication':
									return m('.searchcontainer', [
										m(Publication, {
											mod: 'search',
											tags: this.findPublicationTags(searchResult),
											publication: searchResult,
											lists: this.attrs.data.lists
										}),
										i != data.length - 1 && m('.search-line')
									])
								default:
									return null
							}
						})
					]
				}
			)
		)
	}

	viewInfo(total: number, empty: boolean) {
		if (!this.state.query.size || empty)
			return m('.search-info', t('search.empty'))
		return m('.search-info', [
			m('.search-info-copy', `Search results (${total}) for `),
			m('.search-info-result', this.state.query.valueOf())
		])
	}

	findPublicationTags(publication: PublicationType): Array<string> {
		const {tags} = this.attrs.data.lists
		return publication.tags.map(tag => tags[tag])
	}
	findArticleTags(article: ArticleType): Array<string> {
		const {tags} = this.attrs.data.lists
		return article.tags.map(tag => tags[tag])
	}
}
